import React from 'react';
import ReactDOM from 'react-dom';
import { defaultOptions, initBulletAnimate, isPlainObject, getContainer } from './helper';
import StyledBullet from './StyledBullet';
import px2rem from '../../../utils/px2rem';

export default class BulletScreen {
  target = null;
  options = defaultOptions;
  bullets = [];
  allPaused = false;
  allHide = false;
  tracks = [];
  queues = [];
  bulletStartIndex = 0;
  stop = false;
  animationId = null;
  constructor(ele, opts = {}) {
    // 更新默认配置项
    this.options = Object.assign(this.options, opts);
    const { trackHeight } = this.options;
    // 设置弹幕目标
    if (typeof ele === 'string') {
      this.target = document.querySelector(ele);
      if (!this.target) {
        throw new Error('The display target does not exist');
      }
    } else if (ele instanceof HTMLElement) {
      this.target = ele;
    } else {
      throw new Error('The display target of the barrage must be set');
    }
    // 初始化跑道，全部是空闲状态
    const { height } = this.target.getBoundingClientRect();
    this.tracks = new Array(3).fill('idle');
    // 屏幕目标必须具备的CSS样式
    const { position } = getComputedStyle(this.target);
    if (position === 'static') {
      this.target.style.position = 'relative';
      // this.target.style.overflow = 'hidden';
    }
    // 插入css animation
    initBulletAnimate(this.target);
  }
  _getTrack() {
    let readyIdxs = [];
    let idx = -1;
    // 优先取空闲状态的
    this.tracks.forEach((st, idx) => {
      if (st === 'idle') {
        readyIdxs.push(idx);
      }
    });
    if (readyIdxs.length) {
      idx = readyIdxs[Math.floor(Math.random() * readyIdxs.length)];
    }
    if (idx === -1) {
      // 其次是可以接上状态的
      this.tracks.forEach((st, idx) => {
        if (st === 'feed') {
          readyIdxs.push(idx);
        }
      });
      if (readyIdxs.length) {
        idx = readyIdxs[Math.floor(Math.random() * readyIdxs.length)];
      }
    }
    if (idx !== -1) {
      this.tracks[idx] = 'running';
    }
    return idx;
  }

  push(item, opts = {}, type = 'push') {
    const options = Object.assign({}, this.options, opts);

    const { onStart, onEnd, top } = options;
    const bulletContainer = getContainer({
      ...options,
      currScreen: this
    });

    // 加入当前存在的弹幕列表
    this.bullets.push(bulletContainer);
    const currIdletrack = this._getTrack();
    if (currIdletrack === -1 || this.allPaused) {
      // 考虑到全部暂停的情景
      if (type === 'push') {
        this.queues.push([item, bulletContainer, top]);
      } else {
        this.queues.unshift([item, bulletContainer, top])
      }
    } else {
      this._render(item, bulletContainer, currIdletrack, top);
    }

    if (onStart) {
      // 创建一个监听弹幕动画开始的事件
      bulletContainer.addEventListener('animationstart', () => {
        if (onStart) {
          this.bulletStartIndex = this.bullets.findIndex((obj) => obj.id === bulletContainer.id);
          onStart.call(null, bulletContainer.id, this.bulletStartIndex, this.bullets.length, this);
        }
      });
    }
    // 创建一个监听弹幕动画完成的事件
    bulletContainer.addEventListener('animationend', () => {
      // 如果设置了动画完成自定义函数，则执行
      if (onEnd) {
        this.bulletStartIndex = this.bullets.findIndex((obj) => obj.id === bulletContainer.id);
        onEnd.call(null, bulletContainer.id,  this.bulletStartIndex, this.bullets.length, this);
      }
      // 从集合中剔除
      this.bullets = this.bullets.filter(function (obj) {
        return obj.id !== bulletContainer.id;
      });
      ReactDOM.unmountComponentAtNode(bulletContainer);
      bulletContainer.remove();
    });

    // 返回该容器的ID
    return bulletContainer.id;
  }
  _requestAnimationFrameDom(dom) {
    this.animationId = window.requestAnimationFrame(() => {
      const getBoundingClientRect = dom.getBoundingClientRect();
      if (!this.stop && getBoundingClientRect.right < window.innerWidth - 23) {
        let trackIdx = dom.dataset.track;
        if (this.queues.length) {
          const [item, container, customTop] = this.queues.shift();
          this._render(item, container, trackIdx, customTop);
        } else {
          this.tracks[trackIdx] = 'feed';
        }
      } else {
        this._requestAnimationFrameDom(dom);
      }
    });
  }
  _render = (item, container, track, top) => {
    this.target.appendChild(container);
    const { gap, trackHeight } = this.options;
    // 弹幕渲染进屏幕
    ReactDOM.render(
      React.isValidElement(item) || typeof item === 'string' ? (
        item
      ) : isPlainObject(item) ? (
        <StyledBullet {...item} />
      ) : null,
      container,
      () => {
        container.style.animationDuration = `${this._getAnimateDuration(container.clientWidth)}s`;
        container.style.animationPlayState = 'running';
        let trackTop = track * trackHeight;
        container.dataset.track = track;
        container.style.top = top ? top : px2rem(`${trackTop}px`);
        let options = {
          root: this.target,
          rootMargin: `0px ${gap} 0px 0px`,
          threshold: 1.0
        };
        this._requestAnimationFrameDom(container);
        // let observer = new IntersectionObserver(entries => {
        //   entries.forEach(entry => {
        //     // 完全处于视窗之内
        //     const { intersectionRatio, target } = entry;
        //     if (intersectionRatio >= 1) {
        //       let trackIdx = target.dataset.track;
        //       if (this.queues.length) {
        //         const [item, container, customTop] = this.queues.shift();
        //         this._render(item, container, trackIdx, customTop);
        //       } else {
        //         this.tracks[trackIdx] = 'feed';
        //       }
        //     }
        //   });
        // }, options);
        // observer.observe(container);
      }
    );
  };
  _changeStatus = (id, like_cnt, self_like) => {
    const targetBullets = document.querySelectorAll(`.bullet-item-${id}`);
    for (const item of targetBullets) {
      item.querySelector('.like-cnt').innerHTML = like_cnt > 0 ? like_cnt : '';
      item.querySelector('.self-like').innerHTML = 
        !self_like 
          ? `<img id='praise-icon-${id}' src="https://static.shihuocdn.cn/admin/files/20241030/3fb5328f73d6e71f26565f4cab026ce1.png" alt="" class="icon" />`
          : `<img id='praise-icon-${id}' src="https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png" alt="" class="icon" />`
    }
  }
  _toggleAnimateStatus = (id, status = 'paused') => {
    const currItem = this.bullets.find(item => item.id == id);
    if (currItem) {
      currItem.style.animationPlayState = status;
      return;
    }

    this.allPaused = status === 'paused' ? true : false;
    this.bullets.forEach(item => {
      item.style.animationPlayState = status;
    });
  };
  _getAnimateDuration(width) {
    return (width + 351) / 40.7
  }
  pause(id = null) {
    this._toggleAnimateStatus(id, 'paused');
  }
  resume(id = null) {
    this._toggleAnimateStatus(id, 'running');
  }
  hide() {
    this.allHide = true;
    this.bullets.forEach(item => {
      item.style.opacity = 0;
    });
  }
  show() {
    this.allHide = false;
    this.bullets.forEach(item => {
      item.style.opacity = 1;
    });
  }
  clear(id = null) {
    // const currItem = this.bullets.find(item => item.id == id);
    // if (currItem) {
    //   ReactDOM.unmountComponentAtNode(currItem);
    //   currItem.remove();
    //   this.bullets = this.bullets.filter(function (item) {
    //     return item.id !== id;
    //   });
    //   return;
    // }
    this.bullets.forEach(item => {
      ReactDOM.unmountComponentAtNode(item);
      item.remove();
    });
    // const { height } = this.target.getBoundingClientRect();
    // this.tracks = new Array(Math.floor(height / this.options.trackHeight)).fill('idle');
    // this.queues = [];
    // this.bullets = [];
  }
  destory() {
    this.bullets.forEach(item => {
      ReactDOM.unmountComponentAtNode(item);
      item.remove();
    });
    cancelAnimationFrame(this.animationId);
    this.target = null;
    this.options = defaultOptions;
    this.bullets = [];
    this.allPaused = false;
    this.allHide = false;
    this.tracks = [];
    this.queues = [];
    this.bulletStartIndex = 0;
    this.stop = false;
    this.animationId = null;
  }
}



// WEBPACK FOOTER //
// ./components/pipeline-interactMessage/relyon/BulletScreen.js